module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.iv"
    }
  }), _vm._v("Copyright © 1993 by Wm. B. Eerdmans Publishing Co.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("P.O. Box 163, Cambridge CB3 9PU U.K.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_c('b', [_vm._v("Library of Congress Cataloging-in-Publication Data:")])]), _vm._v(" "), _c('p', {
    staticClass: "cipf1"
  }, [_vm._v("Ashley, Timothy R. 1947–")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("The book of Numbers / by Timothy R. Ashley")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("p. cm. — (The New international commentary on the Old Testament)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Includes "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0015#FRONT.VII"
    }
  }, [_vm._v("bibliographical references")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0031#INDEX1"
    }
  }, [_vm._v("indexes")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("eISBN 978-1-4674-2293-2")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("ISBN 0-8028-2523-0")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("1. Bible. O.T. Numbers—Commentaries.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("I. Title. II. Series.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("BS1265.3.A845 1992")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("222′.14077 — dc20 93-7095")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("CIP")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.eerdmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21aee4a9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-nicot04nu-0003.vue
// module id = 60
// module chunks = 0